import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useUtag } from 'Shared/hooks';
import { transformCSVToString } from 'Shared/utils/transformCSVToString';
import { getClickUtagData } from 'Shared/utils';
import { ETraitsTypes } from 'Shared/types';
import { ExportSettingsControl } from 'Shared/components';
import { getSelectedDataset } from 'Datasets/store';
import { TEALIUM_EVENT } from 'Types/analytics';
import { EXPORT_NAME_SUFFIX } from 'Common/consts';
import { constructExportFileName, getManhattanPlotLegendConfig, transformManhattanPlotToString, } from 'Common/utils';
import { getExportedData } from 'PhenotypeView/store/selectors/levelResults/plr/plr';
const utagData = getClickUtagData({ tealiumEvent: TEALIUM_EVENT.PHENOTYPE_VIEW_EXPORT_DATA });
export const ExportControlContainer = memo(function ExportControlContainer({ exportedHeaders, isFiltersNotChanged, getBinaryPlotDataPointShape, getContinuousPlotDataPointShape, disabled, }) {
    const allTableHeaders = useRef(exportedHeaders);
    const utag = useUtag();
    const { traitsType, phenotype, tableData, allTableData, plotData, allPlotData, } = useSelector(getExportedData);
    const selectedDataset = useSelector(getSelectedDataset);
    const getPlotDataPointShape = traitsType === ETraitsTypes.Binary
        ? getBinaryPlotDataPointShape
        : getContinuousPlotDataPointShape;
    const createArchive = (settings) => {
        const { archiveName, plotFileName, tableFileName, } = constructExportFileName({
            prefix: selectedDataset === null || selectedDataset === void 0 ? void 0 : selectedDataset.name,
            root: `${phenotype.name}`,
            suffixVersionTitle: EXPORT_NAME_SUFFIX,
            allExportedData: settings.allData,
            levelResultSuffix: 'PL',
        });
        const files = Object.assign(Object.assign({}, (settings.table.isActive && {
            [tableFileName]: () => transformCSVToString(settings.allData ? allTableData : tableData, settings.columnSettings ? exportedHeaders : allTableHeaders.current),
        })), (settings.plot.isActive && {
            [plotFileName]: () => transformManhattanPlotToString({
                plotData: settings.allData ? allPlotData : plotData,
                getDataPointShape: getPlotDataPointShape,
                labelsConfig: getManhattanPlotLegendConfig(traitsType),
            }),
        }));
        return [files, archiveName];
    };
    const checkResetExportSettings = (reset) => {
        if (plotData.visiblePointsCount || tableData.length) {
            reset(!plotData.visiblePointsCount, !tableData.length);
        }
    };
    const handleTrackEvent = useCallback(() => {
        utag.link(utagData);
    }, [utag]);
    return (_jsx(ExportSettingsControl, { allData: !!isFiltersNotChanged, checkReset: checkResetExportSettings, getArchive: createArchive, disabled: !tableData.length || disabled, onExport: handleTrackEvent }, void 0));
});
